import type { Comment } from "@/types/comment";

/**
 * Total comments in a thread INCLUDING replies (not just top-level), so count
 * badges/headers reflect the real thread size. Shared by the client drawer badge
 * (ClientCommentsButton) and the task dialog header (TaskDetailsDialog) so the two
 * consumers agree on one definition (ADR-052 S5 review).
 */
export const countComments = (comments: Comment[]): number =>
  comments.reduce((n, c) => n + 1 + (c.replies?.length ?? 0), 0);
